import { MemberProgram, OnboardingPage } from 'app-pages/pages/constants';
import { useMutation } from 'react-query';

import axiosInstance from '../../helpers/axiosInstance';

export const useTrackPageVisit = () => {
  return useMutation({
    mutationFn: async ({ page, patientId, program }: useTrackPageVisitParams) => {
      return axiosInstance.post(`/patients/patients/${patientId}/track_page_visit`, {
        page,
        program,
      });
    },
  });
};

type useTrackPageVisitParams = {
  page: OnboardingPage;
  patientId: string;
  program: MemberProgram;
};
